var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Donwload_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,12.5857864 L9,1 C9,0.44771525 9.44771525,0 10,0 C10.5522847,0 11,0.44771525 11,1 L11,12.5857864 L13.2928932,10.2928932 C13.6834175,9.90236893 14.3165825,9.90236893 14.7071068,10.2928932 C15.0976311,10.6834175 15.0976311,11.3165825 14.7071068,11.7071068 L10.7071068,15.7071068 C10.3165825,16.0976311 9.68341751,16.0976311 9.29289322,15.7071068 L5.29289322,11.7071068 C4.90236893,11.3165825 4.90236893,10.6834175 5.29289322,10.2928932 C5.68341751,9.90236893 6.31658249,9.90236893 6.70710678,10.2928932 L9,12.5857864 Z M0,16 C0,15.4477153 0.44771525,15 1,15 C1.55228475,15 2,15.4477153 2,16 L2,19 C2,19.5522847 2.44771525,20 3,20 L17,20 C17.5522847,20 18,19.5522847 18,19 L18,16 C18,15.4477153 18.4477153,15 19,15 C19.5522847,15 20,15.4477153 20,16 L20,19 C20,20.6568542 18.6568542,22 17,22 L3,22 C1.34314575,22 0,20.6568542 0,19 L0,16 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_matches_over",
    transform: "translate(-1019.000000, -31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(1019.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Donwload_on",
    fill: "#EFB43F",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadHover);
export default __webpack_public_path__ + "static/media/download-hover.fe7d1a3af5f64dbc57c700c4e70ed7e0.svg";
export { ForwardRef as ReactComponent };